import React from 'react';

export default function SupportTickets() {
  return (
    <div>
      <h2 style={s.pageTitle}>Support Tickets</h2>
      <div style={s.card}>
        <div style={s.icon}>🎫</div>
        <h3 style={s.comingTitle}>Coming Soon</h3>
        <p style={s.comingText}>
          Our support ticket system is under development. For now, please reach out via email for any assistance.
        </p>
        <a href="mailto:support@prnewsroom.com" style={s.emailBtn}>
          📧 Contact Support
        </a>
      </div>
    </div>
  );
}

const s = {
  pageTitle: { margin: '0 0 1.5rem', fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e' },
  card: { background: '#fff', borderRadius: 10, padding: '3rem 2rem', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', textAlign: 'center', maxWidth: 500 },
  icon: { fontSize: '3.5rem', marginBottom: '1rem' },
  comingTitle: { margin: '0 0 0.75rem', fontSize: '1.3rem', fontWeight: 700, color: '#1a1a2e' },
  comingText: { margin: '0 0 1.5rem', color: '#666', lineHeight: 1.6 },
  emailBtn: { display: 'inline-block', padding: '0.65rem 1.4rem', background: '#1a62d5', color: '#fff', borderRadius: 6, textDecoration: 'none', fontWeight: 600, fontSize: '0.9rem' },
};
